import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Form,
  Upload,
  message,
  Row,
  Col,
  ColorPicker,
  DatePicker,
} from "antd";
import { UploadOutlined, PlusOutlined, DeleteOutlined, FilePdfOutlined, FileWordOutlined, FileImageOutlined, FileUnknownOutlined } from "@ant-design/icons";
import { RcFile, UploadFile } from "antd/es/upload/interface";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { addRawData, createLeadStatus, getallDeveloperForTask, getAllSources, getAllTags, getLeadStatus } from "../../utils/API"
import dayjs from "dayjs";
import countries from "../../utils/country.json";
import { UploadChangeParam } from "antd/lib/upload";

const { Option } = Select;

const probabilityInputTextStyle: React.CSSProperties = {
  fontFamily: "Inter, sans-serif",
  fontSize: 16,
  fontWeight: 400,
  color: "#333335",
};
const probabilityInputWrapperStyle: React.CSSProperties = {
  ...probabilityInputTextStyle,
  height: 43,
  border: "1px solid #e9edf6",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
};
const probabilityInputStyles = {
  affixWrapper: probabilityInputWrapperStyle,
  input: probabilityInputTextStyle,
  suffix: probabilityInputTextStyle,
};

interface RawdataFormValues {
  contactName: string;
  phone: string;
  phone_2: string;
  company: string;
  leadSource: string[];
  leadTags: string[];
  leadValue: string,
  probability: string,
  description: string,
  title: string;
  link: string;
  leadowner: string;
  country: string;
  date: string;
  rank: string;
  leadstatus: string;
  platform: string
  leadValueCurrency: string,
  leadValueInCurrency: number,
  leadValueInINR: number,
}

interface AddRawDataModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate?: () => void;
  refreshRawData: () => void;
}


const currencies = [

  { code: "USD", name: "US Dollar", symbol: "$", rate: 88.73 },
  { code: "EUR", name: "Euro", symbol: "€", rate: 89.73 },
  { code: "GBP", name: "British Pound", symbol: "£", rate: 104.50 },
  { code: "AUD", name: "Australian Dollar", symbol: "A$", rate: 54.80 },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", rate: 60.45 },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$", rate: 61.80 },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ", rate: 22.65 },
];

// Add this interface for the currency state
interface CurrencyState {
  selectedCurrency: string;
  rate: number | null;          // exchange rate entered by user
  originalValue: number | null; // amount in selected currency
  convertedValue: number | null; // INR total
}




const AddRawDataModal: React.FC<AddRawDataModalProps> = ({
  visible,
  onCancel,
  onCreate,
  refreshRawData,
}) => {
  const [form] = Form.useForm();
  const { authData } = useContext(AuthContext);
  const imageUrl = process.env.REACT_APP_Image_URL || "";
  const [previewImage, setPreviewImage] = useState<string>("");
  const [fileList, setFileList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const roleId = authData?.roleId;
  const isDeveloper =
    roleId?.roleId === 2 || roleId?.name?.toLowerCase() === "developer";
  const [statuses, setStatuses] = useState([]);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [tags, setTags] = useState<Array<{ _id: string; name: string; color: string }>>([]);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isAddingStatus, setIsAddingStatus] = useState(false);
  const [newStatusName, setNewStatusName] = useState("");
  const [newStatusColor, setNewStatusColor] = useState("#000000");
  const [sources, setSources] = useState<Array<string>>([]);
  const [developers, setDevelopers] = useState([]);
  const [platform, setPlatform] = useState([])
  const [Purposal, setPurposal] = useState<Array<string | File>>([]);
  const [fileListPurposal, setFileListPurposal] = useState<any[]>([]);
  const [Prd, setPrd] = useState<Array<string | File>>([]);
  const [fileListPrd, setFileListPrd] = useState<any[]>([]);
  const [Contract, setContract] = useState<(string | File)[]>([]);
  const [fileListContract, setFileListContract] = useState<UploadFile<File>[]>([]);



  const [currencyState, setCurrencyState] = useState<CurrencyState>({
    selectedCurrency: currencies[0].code,
    rate: null,
    originalValue: null,
    convertedValue: null,
  });



  const handleCurrencyChange = (currencyCode: string) => {
    const currency = currencies.find(c => c.code === currencyCode);

    setCurrencyState(prev => ({
      ...prev,
      selectedCurrency: currencyCode,
      rate: currency?.rate || null,
      convertedValue: prev.originalValue && currency?.rate
        ? prev.originalValue * currency.rate
        : null,
    }));
  };





  useEffect(() => {
    if (currencyState.convertedValue !== null) {
      form.setFieldsValue({
        leadValue: Math.round(currencyState.convertedValue * 100) / 100 // Round to 2 decimal places
      });
    }
  }, [currencyState.convertedValue, form]);




  const fetchDevelopers = async () => {
    try {
      const res = await getallDeveloperForTask("", "");
      if (res.data) {
        const owners = res.data.filter((dev: any) => dev.isOwner === true);
        const platform = res.data.filter((dev: any) => dev.isPlatform === true);
        setPlatform(platform)
        setDevelopers(owners);
      }
    } catch (err) {
      console.error("Error fetching developers:", err);
    }
  };

  const fetchTags = async () => {
    try {
      const response = await getAllTags();
      setTags(response.tags || []);
    } catch (error) {
      console.error('Error fetching tags:', error);
      message.error('Failed to fetch tags');
    }
  };


  const handleAddNewStatus = () => setIsAddingStatus(true);

  const handleCancelAddStatus = () => {
    setIsAddingStatus(false);
    setNewStatusName("");
    setNewStatusColor("#000000");
  };

  const handleSaveNewStatus = async () => {

    try {
      const response = await createLeadStatus({
        name: newStatusName,
        color: newStatusColor,
        type: "Rawdata"
      });
      if (response.success) {
        message.success('Status added successfully');
        setIsAddingStatus(false);
        setNewStatusName("");
        setNewStatusColor("#000000");
        await fetchStatuses();
      }
    } catch (error: any) {
      console.error('Error adding status:', error);
      message.error(error?.response?.data?.message || 'Failed to add new status');
    }
  };


  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const formData = new FormData();

      // Append normal fields
      formData.append("title", values.title || "");
      formData.append("email", values.email || "");

      formData.append("link", values.link || "");
      formData.append("country", values.country || "");
      formData.append("phone", values.phone || "");
      formData.append("phone_2", values.phone_2 || "");
      formData.append("contactName", values.contactName || "");
      formData.append("company", values.company || "");
      formData.append("date", values.date ? dayjs(values.date).format("DD-MM-YYYY") : "");
      formData.append("rank", values.rank || "");
      formData.append("leadValueCurrency", values.leadValueCurrency || "");
      formData.append("leadValueInINR", values.leadValueInINR || "");
      formData.append("leadValueInCurrency", values.leadValueInCurrency || "");
      formData.append("leadValue", Math.round(values.leadValue || "").toString());
      formData.append("probability", values.probability || "0");
      formData.append("description", values.description || "");
      formData.append("leadSource", values.leadSource || "");
      formData.append("leadTags", JSON.stringify(values.leadTags || []));
      formData.append("leadstatus", values.leadstatus || ""); // must be ObjectId string
      formData.append("leadowner", values.leadowner || "");
      formData.append("platform", values.platform || "");
      formData.append("leadAssigne", values.leadAssigne || "");

      // Append milestones if available
      if (values.milestones) {
        formData.append("milestones", JSON.stringify(values.milestones));
      }

      // Append Purposal files from state
      Purposal.forEach((file) => {
        formData.append("purposal", file as RcFile);
      });

      // Append PRD files from state
      Prd.forEach((file) => {
        formData.append("prd", file as RcFile);
      });

      // Append Contract files from state
      Contract.forEach((file) => {
        formData.append("contract", file as RcFile);
      });

      const res = await addRawData(formData);

      if (res.data.success) {
        message.success("RawData added successfully!");
        refreshRawData();
        form.resetFields();
        setPurposal([]);
        setPrd([]);
        setContract([]);
        setFileListPurposal([]);
        setFileListPrd([]);
        setFileListContract([]);
        onCancel();
      }
    } catch (error: any) {
      message.error(error?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };



  const fetchSource = async () => {
    try {
      const getSource = await getAllSources(searchText, page);
      if (getSource) {
        let filteredSource = getSource.sources.filter((item: any) =>
          item.category.includes('Sales')
        );
        setSources(filteredSource);
      }
    } catch (error) {
      console.error('Error fetching source:', error);
    }
  };


  const getBase64 = (file: File | Blob): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // <-- semicolon, not comma
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const imageProps = {
    name: "profilePhoto",
    multiple: false,
    beforeUpload: (file: RcFile) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return Upload.LIST_IGNORE;
      }
      const isLt64M = file.size / 1024 / 1024 < 64;
      if (!isLt64M) {
        message.error("Image must be smaller than 64MB!");
        return Upload.LIST_IGNORE;
      }
      return false;
    },
    onChange: async (info: any) => {
      let newFileList = [...info.fileList];
      newFileList = newFileList.slice(-1);

      if (newFileList.length > 0) {
        const file = newFileList[0];
        if (!file.url && !file.preview && file.originFileObj) {
          try {
            file.preview = await getBase64(file.originFileObj);
            setPreviewImage(file.preview);
          } catch (error) {
            console.error("Error generating preview:", error);
          }
        } else {
          setPreviewImage(file.url || file.preview || "");
        }
      } else {
        setPreviewImage("");
      }
      setFileList(newFileList);
    },
    fileList,
  };

  const fetchStatuses = async () => {
    try {
      if (isDeveloper) {
        setStatuses([]);
        return;
      }

      const response = await getLeadStatus();

      setStatuses(response.data);
    } catch (error) {
      console.error('Error fetching statuses:', error);
      message.error('Failed to fetch statuses.');
    }
  };


  const getFileIcon = (fileName: string) => {
    const ext = fileName.split(".").pop()?.toLowerCase();

    if (ext === "pdf") return <FilePdfOutlined className="text-2xl text-red-500 mb-1" />;
    if (ext === "doc" || ext === "docx") return <FileWordOutlined
      className="text-2xl text-blue-500 mb-1" />;
    if (ext === "jpg" || ext === "jpeg" || ext === "png")
      return <FileImageOutlined className="text-2xl text-green-500 mb-1" />;

    // default fallback
    return <FileUnknownOutlined className="text-2xl text-gray-500 mb-1" />;
  };

  const handleDeletePurposal = (doc: string | File, index: number) => {
    const newPurposal = [...Purposal];
    newPurposal.splice(index, 1);
    setPurposal(newPurposal);

    const newFileListPurposal = [...fileListPurposal];
    newFileListPurposal.splice(index, 1);
    setFileListPurposal(newFileListPurposal);
  };

  const handleDeletePrd = (doc: string | File, index: number) => {
    const newPrd = [...Prd];
    newPrd.splice(index, 1);
    setPrd(newPrd);

    const newFileListPrd = [...fileListPrd];
    newFileListPrd.splice(index, 1);
    setFileListPrd(newFileListPrd);
  };

  const handleDeleteContract = (doc: string | File, index: number) => {
    const newContract = [...Contract];
    newContract.splice(index, 1);
    setContract(newContract);

    const newFileListContract = [...fileListContract];
    newFileListContract.splice(index, 1);
    setFileListContract(newFileListContract);
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setFileList([]);
      setPreviewImage("");
      setIsAddingStatus(false);
      setNewStatusName("");
      setNewStatusColor("#000000");
    }
    fetchStatuses();
    fetchSource()
    fetchTags()
    fetchDevelopers();
  }, [visible]);

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
      centered={false}
      destroyOnClose
      className="custom-modal"
      style={{
        top: 20,
        maxHeight: 'calc(100vh - 30px)',
        margin: '0 auto',
        position: 'relative',
      }}
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Add RawData
        </div>
      }
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        colon={false}
        style={{ margin: 0 }}
      >
        <div className="elements">
          {/* <Form.Item>
            <div className="flex justify-center">
              <div className="relative w-20 h-20">
                <Upload.Dragger
                  {...imageProps}
                  className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-blue-500 transition-colors bg-gray-50 overflow-hidden"
                  showUploadList={false}
                >
                  {!previewImage ? (
                    <div className="flex flex-col items-center p-1">
                      <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                        <UploadOutlined className="text-gray-400 text-base" />
                      </div>
                      <span className="text-xs text-gray-400 mt-1">Profile</span>
                    </div>
                  ) : (
                    <img
                      src={previewImage}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />
                  )}
                </Upload.Dragger>

                {previewImage && (
                  <Button
                    type="text"
                    shape="circle"
                    size="small"
                    icon={<MdDeleteOutline size={16} />}
                    className="absolute top-0 right-0 bg-red-500 text-white hover:bg-red-600 shadow-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPreviewImage("");
                      setFileList([]);
                    }}
                  />
                )}
              </div>
            </div>
          </Form.Item> */}

          <Form.Item
            name="title"
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Title<span className="text-danger"></span></span>}
            rules={[{ required: false, message: "Please enter Title" }]}
            required={false}
          >
            <Input
              size="large"
              placeholder="Enter Title"
              className="Allinput"
            />
          </Form.Item>
          <Form.Item
            name="email"
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Email<span className="text-danger"></span></span>}
            rules={[{ required: false, message: "Please enter Email" }]}
            required={false}
          >
            <Input
              size="large"
              placeholder="Enter Email"
              className="Allinput"
            />
          </Form.Item>
          <Form.Item
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>
                Date <span className="text-danger">*</span>
              </span>
            }
            name="date"
            required={false}
            rules={[{ required: true, message: 'Please select date' }]}
          >
            <DatePicker className="Allinput" format="DD-MM-YYYY" style={{ width: '100%' }} />
          </Form.Item>


          <Form.Item
            name="link"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Link <span className="text-danger">*</span></span>}
            rules={[
              { required: true, message: "Please enter Link" },

            ]}
          >
            <Input
              size="large"
              placeholder="Enter Link"
              className="Allinput"
            />
          </Form.Item>
          <Form.Item
            name="leadowner"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Lead Owner <span className="text-danger">*</span></span>}
            rules={[
              { required: true, message: "Please enter Lead Owner" },

            ]}
          >
            <Select placeholder="Owner" className="CustomSelect">
              {developers.map((dev: any) => (
                <Select.Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="platform"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Source Platform ID<span className="text-danger">*</span></span>}
            rules={[
              { required: true, message: "Please enter Source Platform ID" },

            ]}
          >
            <Select placeholder="Source Platform ID" className="CustomSelect">
              {platform.map((pla: any) => (
                <Select.Option key={pla._id} value={pla._id}>
                  {pla.username}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="leadAssigne"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Lead Assignee<span className="text-danger"></span></span>}
            rules={[
              { required: true, message: "Please Select Lead Assignee" },

            ]}
          >
            <Select placeholder=" Select Lead Assignee" className="CustomSelect">
              {developers.map((dev: any) => (
                <Select.Option key={dev._id} value={dev._id}>
                  {dev.username}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="contactName"
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Contact Name <span className="text-danger">*</span></span>}
            rules={[{ required: true, message: "Please enter contact name" }]}
            required={false}
          >
            <Input
              size="large"
              placeholder="Enter Contact Name"
              className="Allinput"
            />
          </Form.Item>
          <Form.Item
            name="phone"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Phone No </span>}
            rules={[
              { required: false, message: "Please enter phone number" },
              {
                validator: (_, value) => {
                  if (!value) {

                    return Promise.resolve();
                  }


                  const cleaned = value.replace(/[^\d+]/g, "");


                  const isValid = /^\+?[1-9]\d{7,14}$/.test(cleaned);

                  if (isValid) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("Please enter a valid phone number"));
                  }
                },
              }


            ]}
          >
            <Input
              type="tel"
              size="large"
              placeholder="Enter Phone No"
              className="Allinput"
            />
          </Form.Item>

          <Form.Item
            name="phone_2"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Phone No 2 </span>}
            rules={[
              { required: false, message: "Please enter phone number 2" },
              {
                validator: (_, value) => {
                  if (!value) {

                    return Promise.resolve();
                  }


                  const cleaned = value.replace(/[^\d+]/g, "");


                  const isValid = /^\+?[1-9]\d{7,14}$/.test(cleaned);

                  if (isValid) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("Please enter a valid phone number"));
                  }
                },
              }


            ]}
          >
            <Input
              type="tel"
              size="large"
              placeholder="Enter Phone No 2"
              className="Allinput"
            />
          </Form.Item>


          <Form.Item
            name="company"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Company Name <span className="text-danger"></span></span>}
            rules={[{ required: false, message: "Please enter company name" }]}
          >
            <Input
              size="large"
              placeholder="Enter Company Name"
              className="Allinput"
            />
          </Form.Item>
          <Form.Item
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>
                Lead Value <span className="text-danger"></span>
              </span>
            }
            required={false}
            rules={[{ required: false, message: "Please enter lead value" }]}
          >
            <div className="flex flex-col m-0 ">
              <div className="flex   gap-2 m-0 h-14">
                <Form.Item name="leadValueCurrency" style={{ margin: 0, flexShrink: 0 }}  >
                  <Select className="CustomSelect !rounded-r-none   "
                    value={currencyState.selectedCurrency}
                    onChange={handleCurrencyChange}
                    style={{ width: 100 }}
                    size="large"
                    placeholder="Select Currency"
                  >
                    {currencies.map((currency) => (
                      <Option key={currency.code} value={currency.code}>
                        {currency.code} ({currency.symbol})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* Amount Input */}
                <Form.Item name="leadValueInCurrency" >
                  <Input
                    size="large"
                    className="border-1 border-gray-200 rounded-md"
                    type="number"
                    placeholder={`Enter Amount in ${currencyState.selectedCurrency}`}
                    value={currencyState.originalValue || ""}
                    onChange={(e) => {
                      let val = parseFloat(e.target.value);
                      if (isNaN(val)) val = 0;
                      val = Math.round(val); // ✅ round to nearest integer

                      setCurrencyState((prev) => ({
                        ...prev,
                        originalValue: val,
                        convertedValue: prev.rate ? val * prev.rate : null,
                      }));
                    }}
                    style={{ flex: 1 }}
                  />
                </Form.Item>

                <div>
                  {/* Enter Exchange Rate */}
                  <Form.Item name="leadValueInINR">
                    <Input
                      size="large"
                      className="border-1 border-gray-200 rounded-md"
                      type="number"
                      placeholder={`1 ${currencyState.selectedCurrency} = ? INR`}
                      value={currencyState.rate || ""}
                      onChange={(e) => {
                        let val = parseFloat(e.target.value);
                        if (isNaN(val)) val = 0;
                        val = Math.round(val); // ✅ round to nearest integer

                        setCurrencyState((prev) => ({
                          ...prev,
                          rate: val,
                          convertedValue: prev.originalValue ? val * prev.originalValue : null,
                        }));
                      }}
                      style={{ flex: 1 }}
                    />
                  </Form.Item>
                </div>


              </div>

              <div className="h-10">

                {/* Converted INR Value */}
                <Form.Item name="leadValue" >
                  <Input
                    size="large"
                    type="number"
                    // readOnly
                    value={currencyState.convertedValue?.toFixed(2) || ""}
                    prefix="₹"
                    className="border-1 border-gray-200 rounded-md"
                  />
                </Form.Item>
              </div>
            </div>
          </Form.Item>


          <Form.Item
            name="probability"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Probability</span>}
          >
            <Input
              size="large"
              placeholder="Enter Probability"
              type="number"
              min={0}
              max={100}
              suffix="%"
              className="Allinput probabilityInput"
              style={probabilityInputWrapperStyle}
              styles={probabilityInputStyles}
            />
          </Form.Item>
          <Form.Item
            name="country"
            label={
              <span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>
                Country <span className="text-danger"></span>
              </span>
            }
            required={false}  // ⛔ prevent AntD from showing its own *
            rules={[{ required: false, message: "Please select a country" }]}
          >
            <Select
              size="large"
              bordered={false}
              placeholder="Select Country"
              // className="Allinput"
              showSearch
              optionFilterProp="children"
            >
              {countries.map((c) => (
                <Select.Option key={c.code} value={c.name}>
                  {c.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>


          <Form.Item
            name="rank"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Rank<span className="text-danger"></span></span>}
          >
            <Input
              size="large"
              placeholder="Enter Rank"
              type="number"
              className="Allinput"
              defaultValue={0}
            />
          </Form.Item>
          <Form.Item
            name="leadstatus"
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Lead Status <span className="text-danger">*</span></span>}
            required={false}
            rules={[{ required: true, message: "Please select the status" }]}
          >
            <Select
              size="large"
              placeholder="Select Lead Status"
              className="CustomSelect"
              open={isStatusDropdownOpen}
              onDropdownVisibleChange={(open) => setIsStatusDropdownOpen(open)}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <div style={{
                    position: 'sticky',
                    bottom: 0,
                    background: '#fff',
                    padding: '3px',
                    borderTop: '1px solid #f0f0f0',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    {isAddingStatus ? (
                      <div className='flex flex-col py-2.5 px-2'>
                        <div className="flex">
                          <Input
                            placeholder="Enter Status Name"
                            value={newStatusName}
                            onChange={(e) => setNewStatusName(e.target.value)}
                            style={{ marginBottom: '8px', width: '90%', height: '35px', borderColor: "#d9d9d9", borderRadius: "5px" }}
                          />
                          <ColorPicker
                            size='small'
                            value={newStatusColor}
                            onChange={(color) => setNewStatusColor(color.toHexString())}
                            onChangeComplete={(color) => setNewStatusColor(color.toHexString())}
                            getPopupContainer={(trigger: any) => trigger.parentElement}
                            style={{ margin: 'auto', padding: "5px" }}
                          />
                        </div>
                        <div className='flex w-full justify-end gap-2'>
                          <Button style={{ width: "140px", height: "35px", borderRadius: '4px' }} size="small" onClick={handleCancelAddStatus}>
                            Cancel
                          </Button>
                          <Button
                            style={{ width: "140px", height: "35px", backgroundColor: "#001529", color: "#ffffff" }}
                            size="small"
                            onClick={handleSaveNewStatus}
                          >
                            Add
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ padding: '4px', width: '100%', display: 'flex', justifyContent: "end" }}>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={handleAddNewStatus}
                          style={{ backgroundColor: "#001529", color: "#ffffff", border: 'none' }}
                        >
                          Add New Status
                        </Button>
                      </div>
                    )}
                  </div>
                </>
              )}
            >
              {statuses?.map((status: any) => (
                <Option key={status?._id} value={status?._id}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: status.color }}>{status.name}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="leadSource"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Lead Source <span className="text-danger">*</span></span>}
            rules={[{ required: true, message: "Please select at least one lead source" }]}
          >
            <Select
              allowClear
              size="large"
              placeholder="Select Lead Source"
              className="CustomSelect"
            >
              {sources.map((item: any, index) => (
                <Option key={index} value={item._id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="leadTags"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Tags <span className="text-danger">*</span></span>}
            rules={[{ required: true, message: "Please select tags" }]}
          >
            <Select
              allowClear
              mode="multiple"
              size="large"
              placeholder="Select Tags"
              className="CustomSelect"
              showSearch
              filterOption={(input, option) =>
                (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
              }
              options={tags.map((tag) => ({
                label: tag.name,
                value: tag._id,
                color: tag.color,
              }))}
              optionRender={(option) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: option.data.color }}>{option.data.label}</span>
                </div>
              )}
            />
          </Form.Item>
          <Form.Item
            name="description"
            label={
              <span
                style={{
                  color: "#4b5563",
                  fontFamily: "inter, sans-serif",
                  fontSize: "14px",
                  paddingLeft: "15px",
                  fontWeight: 500,
                }}
              >
                Description
              </span>
            }
            required={false}
            rules={[
              { required: false, message: "Please enter description" },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter description..."
              className="textarea-input"
              style={{ resize: "none" }}
            />
          </Form.Item>
          <Col span={24}>
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Proposal</span>}
              name="purposal"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div className="text-sm text-gray-500 mb-2">
                  Allowed files: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP (Max 10MB)
                </div>
                <div className="grid grid-cols-[auto,1fr] gap-4 items-start">
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    multiple={true}
                    fileList={fileListPurposal}
                    showUploadList={false}
                    beforeUpload={(file: RcFile) => {
                      // Check file size (10MB max)
                      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
                      if (file.size > maxSize) {
                        message.error(`${file.name} is too large. Maximum file size is 10MB.`);
                        return Upload.LIST_IGNORE;
                      }

                      // Check file type
                      const allowedTypes = [
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/gif',
                        'image/webp'
                      ];
                      const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.webp'];

                      const hasAllowedType = allowedTypes.includes(file.type);
                      const hasAllowedExtension = allowedExtensions.some(ext =>
                        file.name.toLowerCase().endsWith(ext)
                      );

                      if (!hasAllowedType && !hasAllowedExtension) {
                        message.error(
                          `${file.name} is not a supported file type. Allowed types: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP`
                        );
                        return Upload.LIST_IGNORE;
                      }

                      return false; // Prevent auto upload
                    }}
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setPurposal(rawFiles);
                      setFileListPurposal(info.fileList);
                    }}
                  >
                    <Button
                      icon={<UploadOutlined />}
                    >
                      Upload
                    </Button>
                  </Upload>

                  <div className="grid grid-cols-1 gap-3">
                    {Purposal.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${imageUrl}${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between border border-gray-200 rounded-lg p-2 bg-white shadow-sm"
                        >
                          <div className="flex items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-sm font-medium truncate max-w-[250px] hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeletePurposal(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>PRD (Project Requirement Document)</span>}
              name="prd"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div className="text-sm text-gray-500 mb-2">
                  Allowed files: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP (Max 10MB)
                </div>
                <div className="grid grid-cols-[auto,1fr] gap-4 items-start">
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    multiple={true}
                    fileList={fileListPrd}
                    showUploadList={false}
                    beforeUpload={(file: RcFile) => {
                      const maxSize = 10 * 1024 * 1024;
                      if (file.size > maxSize) {
                        message.error(`${file.name} is too large. Maximum file size is 10MB.`);
                        return Upload.LIST_IGNORE;
                      }

                      const allowedTypes = [
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/gif',
                        'image/webp'
                      ];
                      const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.webp'];

                      const hasAllowedType = allowedTypes.includes(file.type);
                      const hasAllowedExtension = allowedExtensions.some(ext =>
                        file.name.toLowerCase().endsWith(ext)
                      );

                      if (!hasAllowedType && !hasAllowedExtension) {
                        message.error(
                          `${file.name} is not a supported file type. Allowed types: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP`
                        );
                        return Upload.LIST_IGNORE;
                      }

                      return false;
                    }}
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setPrd(rawFiles);
                      setFileListPrd(info.fileList);
                    }}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>

                  <div className="grid grid-cols-1 gap-3">
                    {Prd.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${imageUrl}${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between border border-gray-200 rounded-lg p-2 bg-white shadow-sm"
                        >
                          <div className="flex items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-sm font-medium truncate max-w-[250px] hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeletePrd(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <span
                  style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}
                >
                  NDA/Contract
                </span>
              }
              name="contract"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <div className="flex flex-col gap-3">
                <div className="text-sm text-gray-500 mb-2">
                  Allowed files: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP (Max 10MB)
                </div>
                <div
                  className="grid grid-cols-[auto,1fr] gap-4 items-start"
                >
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    multiple
                    fileList={fileListContract}
                    beforeUpload={(file: RcFile) => {
                      // Check file size (10MB max)
                      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
                      if (file.size > maxSize) {
                        message.error(`${file.name} is too large. Maximum file size is 10MB.`);
                        return Upload.LIST_IGNORE;
                      }

                      // Check file type
                      const allowedTypes = [
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/gif',
                        'image/webp'
                      ];
                      const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif', '.webp'];

                      const hasAllowedType = allowedTypes.includes(file.type);
                      const hasAllowedExtension = allowedExtensions.some(ext =>
                        file.name.toLowerCase().endsWith(ext)
                      );

                      if (!hasAllowedType && !hasAllowedExtension) {
                        message.error(
                          `${file.name} is not a supported file type. Allowed types: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF, WEBP`
                        );
                        return Upload.LIST_IGNORE;
                      }

                      return false; // Prevent auto upload
                    }}
                    onChange={(info: UploadChangeParam<UploadFile<RcFile>>) => {
                      const rawFiles = info.fileList
                        .map((f) => f.originFileObj)
                        .filter((f): f is RcFile => !!f);

                      setContract(rawFiles);
                      setFileListContract(info.fileList);
                    }}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>

                  <div className="grid grid-cols-1 gap-3">
                    {Contract.map((doc, index) => {
                      if (!doc) return null;

                      const fileName =
                        typeof doc === "string"
                          ? doc.split("/").pop() || ""
                          : (doc as File).name;

                      const fileUrl =
                        typeof doc === "string"
                          ? `${imageUrl}${doc}`
                          : URL.createObjectURL(doc as File);

                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between border border-gray-200 rounded-lg p-2 bg-white shadow-sm"
                        >
                          <div className="flex items-center gap-2 overflow-hidden">
                            {getFileIcon(fileName)}
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-sm font-medium truncate max-w-[250px] hover:underline"
                            >
                              {fileName}
                            </a>
                          </div>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeleteContract(doc, index);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            <DeleteOutlined />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Form.Item>
          </Col>

        </div>



        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className="allsubmitebutton"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Add..." : "Add"}
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddRawDataModal;
